import styled from 'styled-components';
import { prefix } from '../../tools/settings';
var ProgressTracker = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__ProgressTracker",
  componentId: "sc-1a4ssrj-0"
})(["background:var(--dentsu-color-white);display:flex;align-items:center;padding:var(--dentsu-spacing-16) var(--dentsu-spacing-32);border-radius:10rem;width:100%;"]);
var StepList = styled.ul.withConfig({
  displayName: "ProgressTrackerstyles__StepList",
  componentId: "sc-1a4ssrj-1"
})(["display:flex;align-items:flex-start;width:100%;margin:0;padding:0;list-style-type:none;overflow-x:auto;"]);
var Step = styled.li.withConfig({
  displayName: "ProgressTrackerstyles__Step",
  componentId: "sc-1a4ssrj-2"
})(["position:relative;padding:0 var(--dentsu-spacing-16);flex:1;text-align:center;&:after{content:'';position:absolute;z-index:1;top:24px;left:-50%;width:100%;height:1px;background:var(--dentsu-color-n150);}&.", "-progress-tracker__step--isActive,&.", "-progress-tracker__step--isComplete{&:after{background:var(--dentsu-color-n700);}}&:first-of-type{&:after{display:none;width:0;background:none;}}"], prefix, prefix);
var Wrapper = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__Wrapper",
  componentId: "sc-1a4ssrj-3"
})(["background:var(--dentsu-color-white);position:relative;z-index:2;display:flex;align-items:center;justify-content:center;margin:0 auto var(--dentsu-spacing-4);width:48px;height:48px;.", "-progress-tracker__step--isActive &{width:64px;}"], prefix);
var Number = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__Number",
  componentId: "sc-1a4ssrj-4"
})(["background:var(--dentsu-color-n100);color:var(--dentsu-color-n500);font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-14);line-height:var(--dentsu-leading-tight);margin:auto;display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:16px;.", "-progress-tracker__step--isComplete &{background:var(--dentsu-color-b100);color:var(--dentsu-color-n975);}.", "-progress-tracker__step--isActive &{background:var(--dentsu-color-blue);color:var(--dentsu-color-white);font-size:var(--dentsu-font-size-16);line-height:var(--dentsu-leading-tight);width:48px;height:48px;border-radius:24px;}"], prefix, prefix);
var Badge = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__Badge",
  componentId: "sc-1a4ssrj-5"
})(["background:var(--dentsu-color-white);color:var(--dentsu-color-n500);position:absolute;display:flex;top:-1px;right:-1px;width:22px;height:22px;border-radius:11px;.", "-icon{margin:auto;}.", "-progress-tracker__step--isActive &{top:-3px;right:-3px;}.", "-progress-tracker__step--isComplete &,.", "-progress-tracker__step--isActive &{color:var(--dentsu-color-b550);}"], prefix, prefix, prefix, prefix);
var Label = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__Label",
  componentId: "sc-1a4ssrj-6"
})(["color:var(--dentsu-color-n500);font-size:var(--dentsu-font-size-12);line-height:var(--dentsu-leading-tight);.", "-progress-tracker__step--isComplete &,.", "-progress-tracker__step--isActive &{color:var(--dentsu-color-blue);}"], prefix, prefix);
var Content = styled.div.withConfig({
  displayName: "ProgressTrackerstyles__Content",
  componentId: "sc-1a4ssrj-7"
})(["margin-top:var(--dentsu-spacing-8);"]);
export var Styled = {
  ProgressTracker: ProgressTracker,
  StepList: StepList,
  Step: Step,
  Wrapper: Wrapper,
  Number: Number,
  Badge: Badge,
  Label: Label,
  Content: Content
};